import { ETTypeInfos } from "@cervval.js/common-dto/src/dtoModel.service";
import { keys, typeInfos } from "@cervval.js/ts-reflect";
import { UsersElementTypes } from "../users/user.model";
import { OnapsActivityDataDTO, OnapsAnthropometricMeasuresDTO, OnapsFormDTO, OnapsGarnierFormDTO, OnapsHealthInfoDTO, OnapsPaqFormDTO, OnapsPhysiologicalTestsDTO, OnapsSocialDemographicInfoDTO } from "./onaps.dto";

export type OnapsElementTypes = {
    "onaps_forms": OnapsFormDTO,
    "onaps_social_demographic_infos": OnapsSocialDemographicInfoDTO,
    "onaps_anthropometric_measures": OnapsAnthropometricMeasuresDTO,
    "onaps_health_infos": OnapsHealthInfoDTO,
    "onaps_garnier_forms": OnapsGarnierFormDTO,
    "onaps_physiological_tests": OnapsPhysiologicalTestsDTO,
    "onaps_paq_forms": OnapsPaqFormDTO,
    "onaps_activity_data": OnapsActivityDataDTO
}

export type OnapsElementTypeNames = keyof OnapsElementTypes;
export const OnapsElementTypeNames: OnapsElementTypeNames[] = keys<OnapsElementTypes>();

export const onapsTypeInfos: ETTypeInfos<OnapsElementTypes, OnapsElementTypes & UsersElementTypes> = {
    "onaps_forms": {
        keys: keys<OnapsFormDTO>(),
        typeInfos: typeInfos<OnapsFormDTO>(),
        foreignKeys: {
            companyId: "companies",
            patientId: "user_profiles"
        }
    },
    "onaps_social_demographic_infos": {
        keys: keys<OnapsSocialDemographicInfoDTO>(),
        typeInfos: typeInfos<OnapsSocialDemographicInfoDTO>(),
        foreignKeys: {
            formId: "onaps_forms"
        }
    },
    "onaps_anthropometric_measures": {
        keys: keys<OnapsAnthropometricMeasuresDTO>(),
        typeInfos: typeInfos<OnapsAnthropometricMeasuresDTO>(),
        foreignKeys: {
            formId: "onaps_forms"
        }
    },
    "onaps_health_infos": {
        keys: keys<OnapsHealthInfoDTO>(),
        typeInfos: typeInfos<OnapsHealthInfoDTO>(),
        foreignKeys: {
            formId: "onaps_forms"
        }
    },
    "onaps_garnier_forms": {
        keys: keys<OnapsGarnierFormDTO>(),
        typeInfos: typeInfos<OnapsGarnierFormDTO>(),
        foreignKeys: {
            formId: "onaps_forms"
        }
    },
    "onaps_physiological_tests": {
        keys: keys<OnapsPhysiologicalTestsDTO>(),
        typeInfos: typeInfos<OnapsPhysiologicalTestsDTO>(),
        foreignKeys: {
            formId: "onaps_forms"
        }
    },
    "onaps_paq_forms": {
        keys: keys<OnapsPaqFormDTO>(),
        typeInfos: typeInfos<OnapsPaqFormDTO>(),
        foreignKeys: {
            formId: "onaps_forms"
        }
    },
    "onaps_activity_data": {
        keys: keys<OnapsActivityDataDTO>(),
        typeInfos: typeInfos<OnapsActivityDataDTO>(),
        foreignKeys: {
            formId: "onaps_forms"
        }
    }
};